// extracted by mini-css-extract-plugin
module.exports = {"card":"cardLink_card__1IHVk","chevron":"cardLink_chevron__-PG44","iconCol":"cardLink_iconCol__3JJMl"};